import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _36e86afa = () => interopDefault(import('../pages/login.vue' /* webpackChunkName: "pages/login" */))
const _ed8f835c = () => interopDefault(import('../pages/newsletter/index.vue' /* webpackChunkName: "pages/newsletter/index" */))
const _2275d6f4 = () => interopDefault(import('../pages/profile/index.vue' /* webpackChunkName: "pages/profile/index" */))
const _3298ebe6 = () => interopDefault(import('../pages/reservation.vue' /* webpackChunkName: "pages/reservation" */))
const _58bb242e = () => interopDefault(import('../pages/reservation/index.vue' /* webpackChunkName: "pages/reservation/index" */))
const _6db37e35 = () => interopDefault(import('../pages/reservation/datepicker.vue' /* webpackChunkName: "pages/reservation/datepicker" */))
const _54ad4896 = () => interopDefault(import('../pages/reservation/result.vue' /* webpackChunkName: "pages/reservation/result" */))
const _696690bc = () => interopDefault(import('../pages/settings/index.vue' /* webpackChunkName: "pages/settings/index" */))
const _1344c538 = () => interopDefault(import('../pages/user/index.vue' /* webpackChunkName: "pages/user/index" */))
const _6d7ff87d = () => interopDefault(import('../pages/articles/article/index.vue' /* webpackChunkName: "pages/articles/article/index" */))
const _49807c2d = () => interopDefault(import('../pages/articles/category/index.vue' /* webpackChunkName: "pages/articles/category/index" */))
const _c6917e3c = () => interopDefault(import('../pages/factors/list/index.vue' /* webpackChunkName: "pages/factors/list/index" */))
const _78199468 = () => interopDefault(import('../pages/profile/change-password.vue' /* webpackChunkName: "pages/profile/change-password" */))
const _4a8dae1e = () => interopDefault(import('../pages/reserves/efficiency/index.vue' /* webpackChunkName: "pages/reserves/efficiency/index" */))
const _6efbfa60 = () => interopDefault(import('../pages/reserves/holidays/index.vue' /* webpackChunkName: "pages/reserves/holidays/index" */))
const _47014593 = () => interopDefault(import('../pages/reserves/list/index.vue' /* webpackChunkName: "pages/reserves/list/index" */))
const _cba48f5a = () => interopDefault(import('../pages/reserves/services/index.vue' /* webpackChunkName: "pages/reserves/services/index" */))
const _3830db54 = () => interopDefault(import('../pages/sliders/category/index.vue' /* webpackChunkName: "pages/sliders/category/index" */))
const _3cf34718 = () => interopDefault(import('../pages/sliders/list/index.vue' /* webpackChunkName: "pages/sliders/list/index" */))
const _cb1d049c = () => interopDefault(import('../pages/user/new.vue' /* webpackChunkName: "pages/user/new" */))
const _df1c69ea = () => interopDefault(import('../pages/articles/article/new.vue' /* webpackChunkName: "pages/articles/article/new" */))
const _3dc10a8a = () => interopDefault(import('../pages/articles/category/new.vue' /* webpackChunkName: "pages/articles/category/new" */))
const _37084e1e = () => interopDefault(import('../pages/reserves/holidays/new.vue' /* webpackChunkName: "pages/reserves/holidays/new" */))
const _4edb77a2 = () => interopDefault(import('../pages/sliders/category/new.vue' /* webpackChunkName: "pages/sliders/category/new" */))
const _2bdec0c2 = () => interopDefault(import('../pages/sliders/list/new.vue' /* webpackChunkName: "pages/sliders/list/new" */))
const _7cbbf625 = () => interopDefault(import('../pages/articles/article/_id.vue' /* webpackChunkName: "pages/articles/article/_id" */))
const _652cb456 = () => interopDefault(import('../pages/articles/category/_id.vue' /* webpackChunkName: "pages/articles/category/_id" */))
const _84f7d86c = () => interopDefault(import('../pages/factors/list/_id.vue' /* webpackChunkName: "pages/factors/list/_id" */))
const _8966bff4 = () => interopDefault(import('../pages/reserves/efficiency/_id.vue' /* webpackChunkName: "pages/reserves/efficiency/_id" */))
const _23527938 = () => interopDefault(import('../pages/reserves/holidays/_id.vue' /* webpackChunkName: "pages/reserves/holidays/_id" */))
const _018cde8a = () => interopDefault(import('../pages/reserves/list/_id.vue' /* webpackChunkName: "pages/reserves/list/_id" */))
const _1738990a = () => interopDefault(import('../pages/reserves/services/_id.vue' /* webpackChunkName: "pages/reserves/services/_id" */))
const _3b25a2bc = () => interopDefault(import('../pages/sliders/category/_id.vue' /* webpackChunkName: "pages/sliders/category/_id" */))
const _1828ebdc = () => interopDefault(import('../pages/sliders/list/_id.vue' /* webpackChunkName: "pages/sliders/list/_id" */))
const _f288ae68 = () => interopDefault(import('../pages/user/_id.vue' /* webpackChunkName: "pages/user/_id" */))
const _1ae4276c = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/login",
    component: _36e86afa,
    name: "login"
  }, {
    path: "/newsletter",
    component: _ed8f835c,
    name: "newsletter"
  }, {
    path: "/profile",
    component: _2275d6f4,
    name: "profile"
  }, {
    path: "/reservation",
    component: _3298ebe6,
    children: [{
      path: "",
      component: _58bb242e,
      name: "reservation"
    }, {
      path: "datepicker",
      component: _6db37e35,
      name: "reservation-datepicker"
    }, {
      path: "result",
      component: _54ad4896,
      name: "reservation-result"
    }]
  }, {
    path: "/settings",
    component: _696690bc,
    name: "settings"
  }, {
    path: "/user",
    component: _1344c538,
    name: "user"
  }, {
    path: "/articles/article",
    component: _6d7ff87d,
    name: "articles-article"
  }, {
    path: "/articles/category",
    component: _49807c2d,
    name: "articles-category"
  }, {
    path: "/factors/list",
    component: _c6917e3c,
    name: "factors-list"
  }, {
    path: "/profile/change-password",
    component: _78199468,
    name: "profile-change-password"
  }, {
    path: "/reserves/efficiency",
    component: _4a8dae1e,
    name: "reserves-efficiency"
  }, {
    path: "/reserves/holidays",
    component: _6efbfa60,
    name: "reserves-holidays"
  }, {
    path: "/reserves/list",
    component: _47014593,
    name: "reserves-list"
  }, {
    path: "/reserves/services",
    component: _cba48f5a,
    name: "reserves-services"
  }, {
    path: "/sliders/category",
    component: _3830db54,
    name: "sliders-category"
  }, {
    path: "/sliders/list",
    component: _3cf34718,
    name: "sliders-list"
  }, {
    path: "/user/new",
    component: _cb1d049c,
    name: "user-new"
  }, {
    path: "/articles/article/new",
    component: _df1c69ea,
    name: "articles-article-new"
  }, {
    path: "/articles/category/new",
    component: _3dc10a8a,
    name: "articles-category-new"
  }, {
    path: "/reserves/holidays/new",
    component: _37084e1e,
    name: "reserves-holidays-new"
  }, {
    path: "/sliders/category/new",
    component: _4edb77a2,
    name: "sliders-category-new"
  }, {
    path: "/sliders/list/new",
    component: _2bdec0c2,
    name: "sliders-list-new"
  }, {
    path: "/articles/article/:id",
    component: _7cbbf625,
    name: "articles-article-id"
  }, {
    path: "/articles/category/:id",
    component: _652cb456,
    name: "articles-category-id"
  }, {
    path: "/factors/list/:id",
    component: _84f7d86c,
    name: "factors-list-id"
  }, {
    path: "/reserves/efficiency/:id",
    component: _8966bff4,
    name: "reserves-efficiency-id"
  }, {
    path: "/reserves/holidays/:id",
    component: _23527938,
    name: "reserves-holidays-id"
  }, {
    path: "/reserves/list/:id",
    component: _018cde8a,
    name: "reserves-list-id"
  }, {
    path: "/reserves/services/:id",
    component: _1738990a,
    name: "reserves-services-id"
  }, {
    path: "/sliders/category/:id",
    component: _3b25a2bc,
    name: "sliders-category-id"
  }, {
    path: "/sliders/list/:id",
    component: _1828ebdc,
    name: "sliders-list-id"
  }, {
    path: "/user/:id",
    component: _f288ae68,
    name: "user-id"
  }, {
    path: "/",
    component: _1ae4276c,
    name: "index"
  }],

  parseQuery: function(query) {
      const qs = require("qs");
      return qs.parse(query);
    },
  stringifyQuery: function(query) {
      const qs = require("qs");
      var result = qs.stringify(query);

      return result ? "?" + result : "";
    },
  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
